import { render } from "./PurchaseDeleteModal.vue?vue&type=template&id=d1bba8aa&scoped=true"
import script from "./PurchaseDeleteModal.vue?vue&type=script&lang=js"
export * from "./PurchaseDeleteModal.vue?vue&type=script&lang=js"

import "./PurchaseDeleteModal.vue?vue&type=style&index=0&id=d1bba8aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1bba8aa"]])

export default __exports__